/**
 * Invader (02 §5 type 7): a ground runner, 4 px a tick, never jumping; it falls off edges and turns
 * toward its player on landing. Ported from D_1E9F: first its laser (`invaderLaser`, attack.ts), then
 * the movement from L_1EF6.
 */

import { invaderLaser } from './attack';
import { playerX } from './chase';
import { hit, hitRow, OFF, probe, type Probe } from './map';
import { fallStep, toggleFrame } from './motion';
import type { Monster, PlayerId, World } from '../types';

const RUN_STEP = 4;

/** D_ED12 / D_ED18 via L_ECF7: step 4 px unless on the column grid with a wall beside the lower body. */
function run(world: World, m: Monster, p: Probe, off: number, dx: number): void {
  if (p.subX !== 0 || !hit(world, p, off)) m.x = (m.x + dx) & 0xff;
  else m.ai.joy ^= 3;
}

/**
 * D_1E9F: the laser, then from L_1EF6: falling (D_EB34, whose landing falls through into $EB97: face
 * the player - joystick left when its X >= the player's, else right); off the floor it starts falling
 * (no top-of-screen test here, unlike the walkers); else it runs by its joystick bits.
 */
export function invaderUpdate(world: World, m: Monster, target: PlayerId): void {
  invaderLaser(world, m);
  const a = m.ai;
  const p = probe(m);
  if (!a.falling && !hitRow(world, p, OFF.floor)) a.falling = true;
  if (a.falling) {
    if (fallStep(world, m, p)) {
      a.falling = false;
      a.joy = (a.joy & 4) | (m.x >= playerX(world, target) ? 1 : 2);
    }
    toggleFrame(m);
    return;
  }
  const joy = a.joy;
  if (joy & 1) run(world, m, p, OFF.lowLeft, -RUN_STEP);
  if (joy & 2) run(world, m, p, OFF.lowRight, RUN_STEP);
  toggleFrame(m);
}
